/** @jsx $jsx */
import { $jsx } from 'framework7';
import { setup } from './js/app';
import resolvedConfig from './js/config';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on,
      $f7router = _ref.$f7router,
      $update = _ref.$update,
      $store = _ref.$store;
  var selected = 'home';
  var selectedMedia = 'home';
  var toastBottom;
  var token = $store.getters.token;

  var setItem = function setItem(newItem) {
    selected = newItem;
    $update();
  };

  var setItemMedia = function setItemMedia(newItem) {
    selectedMedia = newItem;
    $update();
  };

  var resolveVisualizer_URL = function resolveVisualizer_URL() {
    var url = 'https://pera-swarm.ce.pdn.ac.lk/visualizer/?key=';
    var storedConfig = localStorage.getItem(document.location.origin + '.config');

    if (token !== undefined && token !== null && token.value) {
      return url + token.value;
    } else {
      return '#';
    }
  };

  var resolveVisualizerAR_URL = function resolveVisualizerAR_URL() {
    var url = 'https://pera-swarm.ce.pdn.ac.lk/visualizer-ar/?key=';
    var storedConfig = localStorage.getItem(document.location.origin + '.config');

    if (token !== undefined && token !== null && token.value) {
      return url + token.value;
    } else {
      return '#';
    }
  };

  var clearCache = function clearCache() {
    $store.dispatch('clearLogs');
  };

  var _window$mqtt = window.mqtt,
      channel = _window$mqtt.channel,
      client = _window$mqtt.client; // console.log(
  //     window.isAuthenticated,
  //     JSON.parse(localStorage.getItem(document.location.origin))
  // );
  // console.log($f7, $on, $f7router, window.mqtt, resolvedConfig);

  var showToastBottom = function showToastBottom(message) {
    // Create toast
    if (!toastBottom) {
      toastBottom = $f7.toast.create({
        text: message,
        closeTimeout: 4000,
        position: "bottom",
        horizontalPosition: "center"
      });
    } // Open it


    toastBottom.open();
  };

  $on('pageInit', function (e, page) {
    setup(showToastBottom);
  });
  $on('pageBeforeRemove', function () {
    if (toastBottom) toastBottom.destroy();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div id="app">
        <!-- SidePanel -->
        <div
            class="panel panel-left panel-cover panel-init"
            data-visible-breakpoint="1024"
            data-collapsed-breakpoint="1"
        >
            <!-- Panel -->
            <div class="list media-list menu-list panel-list">
                <ul>
                    <li>
                        <a
                            href="/"
                            class="item-content item-link ${selectedMedia === 'home' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('home')}"
                        >
                            <div class="item-media">
                                <i class="icon material-icons if-md">settings</i>
                                <i class="icon f7-icons if-not-md">gear_alt_fill</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Settings</div>
                                </div>
                                <!-- <div class="item-subtitle">Home subtitle</div> -->
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/robot/"
                            class="item-content item-link ${selectedMedia === '/robot/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/robot/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">rocket_fill</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Robot</div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/communication/"
                            class="item-content item-link ${selectedMedia === '/communication/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/communication/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">waveform_path_ecg</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Communication</div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/sensors/distance/"
                            class="item-content item-link ${selectedMedia === '/sensors/distance/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/sensors/distance/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">arrow_right_arrow_left</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Distance</div>
                                </div>
                                <div class="item-subtitle">Distance Sensor</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/sensors/proximity/"
                            class="item-content item-link ${selectedMedia === '/sensors/proximity/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/sensors/proximity/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">arrow_right_arrow_left</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Proximity</div>
                                </div>
                                <div class="item-subtitle">Proximity Sensor</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/sensors/color/"
                            class="item-content item-link ${selectedMedia === '/sensors/color/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/sensors/color/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">color_filter</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Color</div>
                                </div>
                                <div class="item-subtitle">Color Sensor</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/neoPixel/"
                            class="item-content item-link ${selectedMedia === '/neoPixel/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/neoPixel/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">circle_grid_hex</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">NeoPixel</div>
                                </div>
                                <div class="item-subtitle">
                                    NeoPixel / RGB Color Strip
                                </div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="/environment/"
                            class="item-content item-link ${selectedMedia === '/environment/' ? 'item-selected' : ''}"
                            @click="${()=> setItemMedia('/environment/')}"
                        >
                            <div class="item-media">
                                <i class="icon f7-icons">cube_fill</i>
                            </div>
                            <div class="item-inner">
                                <div class="item-title-wrap">
                                    <div class="item-title">Environment</div>
                                </div>
                                <div class="item-subtitle">Visualizer & Obstacles</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- End Panel -->
        </div>
        <!-- End SidePanel -->

        <!-- Main View -->
        <div class="view view-main view-init">
            <!-- Navbar -->
            <div class="navbar">
                <div class="navbar-bg"></div>
                <div class="navbar-inner">
                    <div class="left">
                        <a class="link panel-open icon-only" data-panel="left">
                            <i class="icon f7-icons">bars</i>
                        </a>
                    </div>
                    <div class="title">SandBox v2.1</div>
                    <div class="right">
                        <!-- <span class="link" id="theme-toggler"> </span> -->
                        <a class="link popover-open" data-popover=".profile-popover">
                            <img src="static/icons/logo.png" class="avatar" />
                        </a>
                    </div>
                </div>
            </div>
            <!-- End Navbar -->

            <!-- Pop Over -->
            <div class="popover profile-popover">
                <div class="popover-inner">
                    <h5 class="text-align-center margin-top">Pera-Swarm SandBox v2.1</h5>
                    <div
                        class="list no-hairlines no-hairlines-between padding-top padding-bottom"
                    >
                        <ul>
                            <li>
                                <a
                                    href="${resolveVisualizer_URL()}"
                                    class="item-content link external"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div class="item-media">
                                        <i class="icon f7-icons">cube_box</i>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title">Visualizer - 3D</div>
                                    </div>
                                </a>
                            </li>

                            <li>
                                <a
                                    href="${resolveVisualizerAR_URL()}"
                                    class="item-content link external"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div class="item-media">
                                        <i class="icon f7-icons">cube_box</i>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title">Visualizer - AR</div>
                                    </div>
                                </a>
                            </li>

                            <li>
                                <a href="/cache/" class="item-content">
                                    <div class="item-media">
                                        <i class="icon f7-icons">archivebox</i>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title">Logs</div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="item-content" @click="${clearCache}">
                                    <div class="item-media">
                                        <i class="icon f7-icons">xmark_circle_fill</i>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title">Clear Cache</div>
                                    </div>
                                </a>
                            </li>
                            <!-- <li>
                                <a href="#" class="item-content">
                                    <div class="item-media">
                                        <i class="icon f7-icons">wifi_slash</i>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title">Disconnect</div>
                                    </div>
                                </a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <!-- End Pop Over -->

            <!-- Page -->
            <div class="page">
                <div class="fab-backdrop"></div>
                <div class="fab fab-right-bottom">
                    <a href="#">
                        <i class="icon f7-icons if-not-md">plus</i>
                        <i class="icon f7-icons if-not-md">xmark</i>
                        <i class="icon material-icons md-only">add</i>
                        <i class="icon material-icons md-only">close</i>
                    </a>
                    <div class="fab-buttons fab-buttons-top">
                        <a
                            class="fab-label-button link external"
                            href="https://pera-swarm.github.io/docs"
                            target="_blank"
                            rel="noreferrer"
                            ><span>2</span><span class="fab-label">Docs</span></a
                        >
                        <a
                            class="fab-label-button link external"
                            href="${resolveVisualizer_URL()}"
                            target="_blank"
                            rel="noreferrer"
                            ><span>1</span
                            ><span class="fab-label">Visualizer - 3D</span></a
                        >
                        <a
                            class="fab-label-button link external"
                            href="${resolveVisualizerAR_URL()}"
                            target="_blank"
                            rel="noreferrer"
                            ><span>1</span
                            ><span class="fab-label">Visualizer - AR</span></a
                        >
                    </div>
                </div>

                <!-- Config Page Content -->
                <div class="page-content">
                    <div class="container pt-2">
                        <!-- <h3>Neo Pixel LED Ring</h3> -->
                        <!-- Color Control -->
                        <div class="block-title">Current Settings (1)</div>
                        <div class="card p-2">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="list inline-labels">
                                        <ul>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons">tray_2</i>
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Server
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt_server"
                                                            type="text"
                                                            placeholder="MQTT Server"
                                                            disabled="{true}"
                                                            value="${client.host}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons"
                                                        >textformat_123</i
                                                    >
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Port
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt_port"
                                                            type="text"
                                                            placeholder="MQTT Port"
                                                            disabled="{true}"
                                                            value="${client.port}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons"
                                                        >number_square</i
                                                    >
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        ClientID
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt_client_id"
                                                            type="text"
                                                            placeholder="MQTT Client ID"
                                                            disabled="{true}"
                                                            value="${client.clientId}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons"
                                                        >dot_radiowaves_left_right</i
                                                    >
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Channel
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt_channel"
                                                            type="text"
                                                            placeholder="MQTT Channel"
                                                            disabled="{true}"
                                                            value="${channel}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <!-- <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons">wifi</i>
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Connected?
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="status"
                                                            type="text"
                                                            placeholder="Connection Status"
                                                            disabled="{true}"
                                                            value="${client.isConnected()}"
                                                        />
                                                    </div>
                                                </div>
                                            </li> -->
                                        </ul>
                                        <button
                                            class="button button-raised button-fill color-green popup-open my-2"
                                            data-popup=".popup-services"
                                        >
                                            Change
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="block-title">Authentication</div>
                                    <div class="list inline-labels">
                                        <ul>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons">person</i>
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Username
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt-username"
                                                            type="text"
                                                            placeholder="MQTT Username"
                                                            value="${window.username}"
                                                            disabled="${window.isAuthenticated}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input">
                                                <div class="item-media">
                                                    <i class="icon f7-icons">lock</i>
                                                </div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">
                                                        Password
                                                    </div>
                                                    <div class="item-input-wrap">
                                                        <input
                                                            id="mqtt-password"
                                                            type="password"
                                                            placeholder="MQTT Password"
                                                            value="${window.password}"
                                                            disabled="${isAuthenticated}"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        ${window.isAuthenticated === true ?
                                        <button
                                            class="button button-raised button-fill color-red my-2 disconnect-button-cls"
                                            id="disconnect-button"
                                        >
                                            Disconnect
                                        </button>
                                        :
                                        <button
                                            class="button button-raised button-fill color-blue my-2"
                                            id="connect-button"
                                        >
                                            Connect
                                        </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Settings Form Pop Up -->
                        <div class="popup popup-services">
                            <div class="page-content container p-2">
                                <div class="block">
                                    <div class="card col">
                                        <div class="list inline-labels mt-5">
                                            <ul>
                                                <li class="item-content item-input">
                                                    <div class="item-media">
                                                        <i class="icon f7-icons"
                                                            >tray_2</i
                                                        >
                                                    </div>
                                                    <div class="item-inner">
                                                        <div
                                                            class="item-title item-label"
                                                        >
                                                            Server
                                                        </div>
                                                        <div class="item-input-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="MQTT Server"
                                                                value="${client.host}"
                                                                id="input-server"
                                                            />
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="item-content item-input">
                                                    <div class="item-media">
                                                        <i class="icon f7-icons"
                                                            >textformat_123</i
                                                        >
                                                    </div>
                                                    <div class="item-inner">
                                                        <div
                                                            class="item-title item-label"
                                                        >
                                                            Port
                                                        </div>
                                                        <div class="item-input-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="MQTT Port"
                                                                value="${client.port}"
                                                                id="input-port"
                                                            />
                                                            <div class="item-input-info">
                                                                (Default: 8883)
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="item-content item-input">
                                                    <div class="item-media">
                                                        <i class="icon f7-icons"
                                                            >number_square</i
                                                        >
                                                    </div>
                                                    <div class="item-inner">
                                                        <div
                                                            class="item-title item-label"
                                                        >
                                                            ClientID
                                                        </div>
                                                        <div class="item-input-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="MQTT Client ID"
                                                                disabled
                                                                id="input-client-id"
                                                                value="${client.clientId}"
                                                            />
                                                            <div class="item-input-info">
                                                                (Automatically generated)
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="item-content item-input">
                                                    <div class="item-media">
                                                        <i class="icon f7-icons"
                                                            >dot_radiowaves_left_right</i
                                                        >
                                                    </div>
                                                    <div class="item-inner">
                                                        <div
                                                            class="item-title item-label"
                                                        >
                                                            Channel
                                                        </div>
                                                        <div class="item-input-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="MQTT Channel"
                                                                id="input-channel"
                                                                value="${channel}"
                                                            />
                                                            <div class="item-input-info">
                                                                (Default: v1)
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div class="row m-3 pt-5">
                                                <div class="col col-md-8"></div>
                                                <div class="col col-md-2">
                                                    <button
                                                        class="button button-raised button-fill color-red popup-close"
                                                        data-popup=".popup-services"
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                                <div class="col col-md-2">
                                                    <button
                                                        class="button button-raised button-fill color-primary settings-popup-save-button"
                                                        data-popup=".popup-services"
                                                        id="settings-popup-save-button-1"
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Settings Form Pop Up -->
                    </div>
                </div>
                <!-- End Config Page Content -->
            </div>
            <!-- End Page -->
        </div>
        <!-- End Main View -->
    </div>
`
    }
    ;
});